// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero */
.hero {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  background: linear-gradient(160deg, #FDF6EC 0%, #F5E8D0 50%, #EDD8B0 100%);
  overflow: hidden;
  padding: 170px 0 60px;
}

.hero-bg-pattern {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 10% 20%, rgba(200, 134, 10, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 90% 80%, rgba(196, 72, 10, 0.07) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(200, 134, 10, 0.05) 0%, transparent 70%);
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.hero-title {
  font-size: 3.2rem;
  line-height: 1.2;
  color: var(--brown);
  margin-bottom: 20px;
}

.hero-highlight {
  background: linear-gradient(135deg, var(--gold), var(--orange));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: var(--text-mid);
  margin-bottom: 32px;
  max-width: 580px;
  line-height: 1.8;
}

.hero-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 56px;
}

.hero-stats {
  display: flex;
  gap: 0;
  border: 1px solid rgba(200, 134, 10, 0.2);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  overflow: hidden;
  width: fit-content;
}

.hero-stat {
  padding: 20px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border-right: 1px solid rgba(200, 134, 10, 0.15);
}

.hero-stat:last-child {
  border-right: none;
}

.stat-num {
  font-size: 1.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--text-light);
  font-weight: 500;
  white-space: nowrap;
}

.hero-ornament {
  position: absolute;
  right: -60px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.om-circle {
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(200,134,10,0.12) 0%, transparent 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(200,134,10,0.1);
}

.om-symbol {
  font-size: 9rem;
  opacity: 0.25;
  filter: drop-shadow(0 0 40px rgba(200,134,10,0.3));
}

/* Features */
.features-section {
  background: var(--white);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  text-align: center;
  cursor: pointer;
  display: block;
}

.feature-icon {
  font-size: 2.8rem;
  margin-bottom: 16px;
  line-height: 1;
}

.feature-card h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: var(--gold-dark);
}

.feature-card p {
  font-size: 0.88rem;
  color: var(--text-mid);
  line-height: 1.7;
  margin-bottom: 16px;
}

.feature-link {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gold);
}

/* About Strip */
.about-strip {
  background: linear-gradient(135deg, var(--cream) 0%, var(--cream-dark) 100%);
}

.about-strip-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}

.about-strip-text .badge {
  margin-bottom: 12px;
}

.about-strip-text h2 {
  font-size: 2rem;
  margin-bottom: 16px;
}

.about-strip-text p {
  color: var(--text-mid);
  margin-bottom: 12px;
  line-height: 1.8;
}

.ganesha-card {
  background: linear-gradient(135deg, rgba(200,134,10,0.08), rgba(196,72,10,0.05));
  border: 1px solid rgba(200,134,10,0.2);
  border-radius: 20px;
  padding: 40px 32px;
  text-align: center;
}

.ganesha-emoji {
  font-size: 4rem;
  margin-bottom: 20px;
}

.ganesha-card blockquote {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
  font-style: italic;
  color: var(--gold-dark);
  line-height: 1.8;
  margin-bottom: 12px;
}

.shloka-translate {
  font-size: 0.82rem;
  color: var(--text-light);
}

/* Events */
.events-section {
  background: var(--white);
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.event-row {
  display: flex;
  align-items: center;
  gap: 24px;
}

.event-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  color: var(--white);
  border-radius: 12px;
  padding: 12px 18px;
  min-width: 72px;
  flex-shrink: 0;
}

.event-day {
  font-size: 1.8rem;
  font-weight: 800;
  line-height: 1;
}

.event-month {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.event-info {
  flex: 1 1;
}

.event-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--gold);
  background: rgba(200,134,10,0.1);
  padding: 2px 10px;
  border-radius: 20px;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.event-info h3 {
  font-size: 1.05rem;
  margin-bottom: 4px;
  color: var(--brown);
}

.event-info p {
  font-size: 0.85rem;
  color: var(--text-light);
}

/* Donate CTA */
.donate-cta {
  background: linear-gradient(135deg, #2C1A06, #1A0E04);
  color: var(--white);
}

.donate-cta-inner {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 48px;
  align-items: center;
}

.donate-cta-text h2 {
  color: var(--gold-light);
  font-size: 2rem;
  margin-bottom: 12px;
}

.donate-cta-text p {
  color: rgba(255,255,255,0.7);
  line-height: 1.8;
  margin-bottom: 20px;
}

.donate-amounts {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.amount-chip {
  padding: 8px 20px;
  border: 1.5px solid rgba(200, 134, 10, 0.5);
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--gold-light);
  transition: all 0.2s ease;
  cursor: pointer;
}

.amount-chip:hover {
  background: var(--gold);
  border-color: var(--gold);
  color: var(--white);
  transform: translateY(-2px);
}

.donate-big-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  color: var(--white);
  padding: 24px 40px;
  border-radius: 16px;
  font-size: 1.2rem;
  font-weight: 700;
  box-shadow: 0 8px 32px rgba(200,134,10,0.4);
  transition: all 0.3s ease;
  white-space: nowrap;
}

.donate-big-btn span:first-child {
  font-size: 2rem;
}

.donate-big-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(200,134,10,0.5);
}

.donate-note {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.5);
  text-align: center;
  margin-top: 10px;
}

/* Testimonials */
.testimonials-section {
  background: var(--cream);
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.testimonial-avatar {
  font-size: 2.4rem;
  text-align: center;
}

.testimonial-text {
  font-size: 0.9rem;
  color: var(--text-mid);
  line-height: 1.8;
  font-style: italic;
  flex: 1 1;
}

.testimonial-author {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 12px;
  border-top: 1px solid rgba(200,134,10,0.15);
}

.testimonial-author strong {
  font-size: 0.9rem;
  color: var(--gold-dark);
}

.testimonial-author span {
  font-size: 0.78rem;
  color: var(--text-light);
}

/* Register CTA */
.register-cta {
  background: linear-gradient(135deg, var(--cream-dark), var(--cream));
  padding: 80px 0;
}

.register-cta h2 {
  font-size: 2.2rem;
  margin-bottom: 12px;
}

.register-cta p {
  color: var(--text-mid);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Responsive */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .about-strip-inner {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .donate-cta-inner {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .donate-amounts {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .hero-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .hero-stat {
    border-right: 1px solid rgba(200, 134, 10, 0.15);
    border-bottom: 1px solid rgba(200, 134, 10, 0.15);
    padding: 18px 16px;
  }

  .hero-stat:nth-child(2),
  .hero-stat:nth-child(4) {
    border-right: none;
  }

  .hero-stat:nth-child(3),
  .hero-stat:nth-child(4) {
    border-bottom: none;
  }

  .stat-label {
    white-space: normal;
    text-align: center;
    font-size: 0.72rem;
  }

  .hero-ornament {
    display: none;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .event-row {
    flex-wrap: wrap;
  }
}

@media (max-width: 560px) {
  .hero-title {
    font-size: 1.8rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0EAA0E;EAC1E,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;oFAGkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8EAA8E;EAC9E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kDAAkD;AACpD;;AAEA,aAAa;AACb;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gFAAgF;EAChF,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+DAA+D;EAC/D,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,gDAAgD;IAChD,iDAAiD;IACjD,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Hero */\n.hero {\n  min-height: 100vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: linear-gradient(160deg, #FDF6EC 0%, #F5E8D0 50%, #EDD8B0 100%);\n  overflow: hidden;\n  padding: 170px 0 60px;\n}\n\n.hero-bg-pattern {\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 10% 20%, rgba(200, 134, 10, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 90% 80%, rgba(196, 72, 10, 0.07) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(200, 134, 10, 0.05) 0%, transparent 70%);\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n}\n\n.hero-title {\n  font-size: 3.2rem;\n  line-height: 1.2;\n  color: var(--brown);\n  margin-bottom: 20px;\n}\n\n.hero-highlight {\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-mid);\n  margin-bottom: 32px;\n  max-width: 580px;\n  line-height: 1.8;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 56px;\n}\n\n.hero-stats {\n  display: flex;\n  gap: 0;\n  border: 1px solid rgba(200, 134, 10, 0.2);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(8px);\n  overflow: hidden;\n  width: fit-content;\n}\n\n.hero-stat {\n  padding: 20px 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  border-right: 1px solid rgba(200, 134, 10, 0.15);\n}\n\n.hero-stat:last-child {\n  border-right: none;\n}\n\n.stat-num {\n  font-size: 1.8rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--text-light);\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.hero-ornament {\n  position: absolute;\n  right: -60px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.om-circle {\n  width: 500px;\n  height: 500px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(200,134,10,0.12) 0%, transparent 70%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid rgba(200,134,10,0.1);\n}\n\n.om-symbol {\n  font-size: 9rem;\n  opacity: 0.25;\n  filter: drop-shadow(0 0 40px rgba(200,134,10,0.3));\n}\n\n/* Features */\n.features-section {\n  background: var(--white);\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.feature-card {\n  text-align: center;\n  cursor: pointer;\n  display: block;\n}\n\n.feature-icon {\n  font-size: 2.8rem;\n  margin-bottom: 16px;\n  line-height: 1;\n}\n\n.feature-card h3 {\n  font-size: 1.1rem;\n  margin-bottom: 10px;\n  color: var(--gold-dark);\n}\n\n.feature-card p {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n  margin-bottom: 16px;\n}\n\n.feature-link {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--gold);\n}\n\n/* About Strip */\n.about-strip {\n  background: linear-gradient(135deg, var(--cream) 0%, var(--cream-dark) 100%);\n}\n\n.about-strip-inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 64px;\n  align-items: center;\n}\n\n.about-strip-text .badge {\n  margin-bottom: 12px;\n}\n\n.about-strip-text h2 {\n  font-size: 2rem;\n  margin-bottom: 16px;\n}\n\n.about-strip-text p {\n  color: var(--text-mid);\n  margin-bottom: 12px;\n  line-height: 1.8;\n}\n\n.ganesha-card {\n  background: linear-gradient(135deg, rgba(200,134,10,0.08), rgba(196,72,10,0.05));\n  border: 1px solid rgba(200,134,10,0.2);\n  border-radius: 20px;\n  padding: 40px 32px;\n  text-align: center;\n}\n\n.ganesha-emoji {\n  font-size: 4rem;\n  margin-bottom: 20px;\n}\n\n.ganesha-card blockquote {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n  font-style: italic;\n  color: var(--gold-dark);\n  line-height: 1.8;\n  margin-bottom: 12px;\n}\n\n.shloka-translate {\n  font-size: 0.82rem;\n  color: var(--text-light);\n}\n\n/* Events */\n.events-section {\n  background: var(--white);\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.event-row {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.event-date {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  color: var(--white);\n  border-radius: 12px;\n  padding: 12px 18px;\n  min-width: 72px;\n  flex-shrink: 0;\n}\n\n.event-day {\n  font-size: 1.8rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.event-month {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.event-info {\n  flex: 1;\n}\n\n.event-badge {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--gold);\n  background: rgba(200,134,10,0.1);\n  padding: 2px 10px;\n  border-radius: 20px;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.event-info h3 {\n  font-size: 1.05rem;\n  margin-bottom: 4px;\n  color: var(--brown);\n}\n\n.event-info p {\n  font-size: 0.85rem;\n  color: var(--text-light);\n}\n\n/* Donate CTA */\n.donate-cta {\n  background: linear-gradient(135deg, #2C1A06, #1A0E04);\n  color: var(--white);\n}\n\n.donate-cta-inner {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 48px;\n  align-items: center;\n}\n\n.donate-cta-text h2 {\n  color: var(--gold-light);\n  font-size: 2rem;\n  margin-bottom: 12px;\n}\n\n.donate-cta-text p {\n  color: rgba(255,255,255,0.7);\n  line-height: 1.8;\n  margin-bottom: 20px;\n}\n\n.donate-amounts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.amount-chip {\n  padding: 8px 20px;\n  border: 1.5px solid rgba(200, 134, 10, 0.5);\n  border-radius: 50px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--gold-light);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.amount-chip:hover {\n  background: var(--gold);\n  border-color: var(--gold);\n  color: var(--white);\n  transform: translateY(-2px);\n}\n\n.donate-big-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  color: var(--white);\n  padding: 24px 40px;\n  border-radius: 16px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  box-shadow: 0 8px 32px rgba(200,134,10,0.4);\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.donate-big-btn span:first-child {\n  font-size: 2rem;\n}\n\n.donate-big-btn:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 40px rgba(200,134,10,0.5);\n}\n\n.donate-note {\n  font-size: 0.75rem;\n  color: rgba(255,255,255,0.5);\n  text-align: center;\n  margin-top: 10px;\n}\n\n/* Testimonials */\n.testimonials-section {\n  background: var(--cream);\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.testimonial-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.testimonial-avatar {\n  font-size: 2.4rem;\n  text-align: center;\n}\n\n.testimonial-text {\n  font-size: 0.9rem;\n  color: var(--text-mid);\n  line-height: 1.8;\n  font-style: italic;\n  flex: 1;\n}\n\n.testimonial-author {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(200,134,10,0.15);\n}\n\n.testimonial-author strong {\n  font-size: 0.9rem;\n  color: var(--gold-dark);\n}\n\n.testimonial-author span {\n  font-size: 0.78rem;\n  color: var(--text-light);\n}\n\n/* Register CTA */\n.register-cta {\n  background: linear-gradient(135deg, var(--cream-dark), var(--cream));\n  padding: 80px 0;\n}\n\n.register-cta h2 {\n  font-size: 2.2rem;\n  margin-bottom: 12px;\n}\n\n.register-cta p {\n  color: var(--text-mid);\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.8;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .about-strip-inner {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .donate-cta-inner {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n\n  .donate-amounts {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.2rem;\n  }\n\n  .hero-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n  }\n\n  .hero-stat {\n    border-right: 1px solid rgba(200, 134, 10, 0.15);\n    border-bottom: 1px solid rgba(200, 134, 10, 0.15);\n    padding: 18px 16px;\n  }\n\n  .hero-stat:nth-child(2),\n  .hero-stat:nth-child(4) {\n    border-right: none;\n  }\n\n  .hero-stat:nth-child(3),\n  .hero-stat:nth-child(4) {\n    border-bottom: none;\n  }\n\n  .stat-label {\n    white-space: normal;\n    text-align: center;\n    font-size: 0.72rem;\n  }\n\n  .hero-ornament {\n    display: none;\n  }\n\n  .testimonials-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .event-row {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 560px) {\n  .hero-title {\n    font-size: 1.8rem;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
